import React, { useState, useRef, useEffect } from 'react';

/**
 * FilterDropdown Component - A reusable dropdown for multi-select filtering.
 */
export function FilterDropdown({ 
    label, 
    options, 
    selectedValues, 
    onToggle, 
    onSelectAll, 
    onSelectNone,
    placeholder = "Suchen...",
    icon = "⚙️"
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    // Close when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const filteredOptions = options.filter(opt => 
        (opt.label || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    const activeCount = selectedValues.length;
    const isAll = activeCount === options.length;

    const getLabel = () => {
        if (isAll) return `Alle ${label}`;
        if (activeCount === 0) return `Keine ${label}`;
        if (activeCount === 1) {
            const opt = options.find(o => String(o.value) === String(selectedValues[0]));
            return opt ? opt.label : label;
        }
        return `${activeCount} ${label}`;
    };

    return (
        <div className="employee-filter-dropdown" ref={dropdownRef}>
            <button 
                className={`filter-dropdown-btn ${isOpen ? 'active' : ''} ${activeCount > 0 ? 'has-selection' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{icon}</span>
                    <span>{getLabel()}</span>
                </div>
                <span style={{ fontSize: '10px', opacity: 0.5 }}>{isOpen ? '▲' : '▼'}</span>
            </button>

            {isOpen && (
                <div className="filter-dropdown-menu">
                    <div className="filter-dropdown-search-wrapper">
                        <input
                            className="filter-dropdown-search-input"
                            type="text"
                            placeholder={placeholder}
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                    </div>

                    <div className="filter-dropdown-menu-list">
                        {filteredOptions.length === 0 ? (
                            <div style={{ padding: '20px', textAlign: 'center', fontSize: '11px', color: '#86868b' }}>
                                Keine Treffer
                            </div>
                        ) : (
                            filteredOptions.map(opt => (
                                <div 
                                    key={opt.value} 
                                    className={`employee-filter-item ${selectedValues.includes(String(opt.value)) ? 'selected' : ''}`}
                                    onClick={() => onToggle(opt.value)}
                                >
                                    <div className="employee-custom-checkbox">
                                        {selectedValues.includes(String(opt.value)) && <span className="checkmark">✓</span>}
                                    </div>
                                    <span className="filter-item-label">{opt.label}</span>
                                </div>
                            ))
                        )}
                    </div>

                    <div className="filter-actions-row">
                        <div className="filter-action-btn" onClick={onSelectAll}>Alle</div>
                        <div style={{ width: '1px', background: 'rgba(0,0,0,0.05)' }} />
                        <div className="filter-action-btn" style={{ color: '#ff3b30' }} onClick={onSelectNone}>Keine</div>
                    </div>
                </div>
            )}
        </div>
    );
}
